function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M355.737 180.567L355.13 184.3L354.476 188.311L348.511 224.889H338.755L344.72 188.311L345.373 184.3L345.981 180.567H355.737Z",
  fill: "#ECECEC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M354.324 180.567C353.81 184.273 353.257 187.971 352.699 191.669L350.979 202.757L349.175 213.832L348.245 219.364L347.277 224.891L348.07 219.336L348.902 213.788L350.622 202.7L352.425 191.626C353.042 187.937 353.663 184.249 354.324 180.567Z",
  fill: "#C8C8C8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M355.13 184.3L354.476 188.311H344.72L345.374 184.3H355.13Z",
  fill: "#C8C8C8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M403.899 180.567L404.506 184.3L405.16 188.311L411.126 224.889H420.882L414.916 188.311L414.263 184.3L413.655 180.567H403.899Z",
  fill: "#ECECEC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M405.343 180.567C405.857 184.273 406.41 187.971 406.969 191.669L408.688 202.757L410.492 213.832L411.423 219.364L412.39 224.891L411.597 219.336L410.766 213.788L409.045 202.7L407.242 191.626C406.626 187.937 406.004 184.249 405.343 180.567Z",
  fill: "#C8C8C8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M404.506 184.3H414.263L414.916 188.311H405.161L404.506 184.3Z",
  fill: "#C8C8C8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M355.382 170.277H347.646L348.608 163.067H354.42L355.382 170.277Z",
  fill: "#C8C8C8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M358.723 157.913C358.723 161.895 355.495 165.122 351.514 165.122C347.533 165.122 344.305 161.895 344.305 157.913C344.305 153.932 347.533 150.704 351.514 150.704C355.495 150.704 358.723 153.932 358.723 157.913Z",
  fill: "#DCDCDC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M356.994 157.914C356.994 160.94 354.54 163.393 351.514 163.393C348.487 163.393 346.034 160.94 346.034 157.914C346.034 154.887 348.487 152.434 351.514 152.434C354.54 152.434 356.994 154.887 356.994 157.914Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M356.095 157.597C355.998 156.257 355.317 155.025 354.305 154.233C353.291 153.438 351.948 153.07 350.62 153.268C349.336 153.46 348.169 154.222 347.452 155.328C346.726 156.434 346.48 157.885 346.874 159.281C347.191 160.425 347.99 161.417 349.014 161.989C350.036 162.572 351.259 162.751 352.368 162.505C353.485 162.271 354.491 161.645 355.182 160.782C355.879 159.925 356.296 158.843 356.341 157.73C356.343 157.676 356.325 157.632 356.297 157.631C356.271 157.631 356.247 157.671 356.244 157.725C356.226 158.177 356.127 158.621 355.988 159.046C355.839 159.47 355.631 159.867 355.383 160.236C355.126 160.6 354.823 160.929 354.485 161.222C354.141 161.509 353.759 161.755 353.348 161.958C352.185 162.515 350.8 162.555 349.607 162.047C348.415 161.549 347.456 160.516 347.069 159.263C346.655 157.938 346.859 156.521 347.549 155.427C348.234 154.336 349.379 153.58 350.633 153.399C352.364 153.15 354.113 153.785 355.173 155.206C355.428 155.556 355.629 155.941 355.785 156.345C355.933 156.752 356.024 157.18 356.072 157.618C356.075 157.631 356.082 157.635 356.088 157.631C356.095 157.626 356.098 157.611 356.095 157.597Z",
  fill: "#ECECEC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M355.453 157.601C355.357 156.45 354.766 155.406 353.9 154.731C353.031 154.055 351.893 153.739 350.753 153.895C349.653 154.048 348.64 154.693 348.01 155.643C347.374 156.59 347.148 157.849 347.479 159.067C347.744 160.065 348.441 160.937 349.336 161.435C350.228 161.941 351.296 162.094 352.262 161.872C353.231 161.662 354.101 161.114 354.697 160.362C355.298 159.615 355.656 158.682 355.699 157.716C355.701 157.67 355.683 157.632 355.655 157.631C355.629 157.631 355.606 157.666 355.603 157.713C355.522 159.292 354.517 160.678 353.1 161.366C352.103 161.855 350.897 161.898 349.864 161.459C348.831 161.031 347.998 160.13 347.672 159.044C347.322 157.895 347.509 156.67 348.111 155.738C348.708 154.804 349.699 154.168 350.767 154.026C352.246 153.834 353.72 154.357 354.64 155.562C354.86 155.861 355.033 156.187 355.171 156.531C355.301 156.878 355.383 157.242 355.431 157.62C355.434 157.631 355.441 157.635 355.447 157.631C355.454 157.626 355.456 157.614 355.453 157.601Z",
  fill: "#ECECEC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M354.811 157.606C354.715 156.642 354.216 155.788 353.495 155.228C352.772 154.673 351.839 154.408 350.885 154.523C349.969 154.637 349.111 155.165 348.569 155.958C348.022 156.745 347.816 157.813 348.083 158.853C348.298 159.706 348.893 160.457 349.659 160.881C350.421 161.311 351.333 161.435 352.155 161.24C352.978 161.054 353.712 160.583 354.213 159.942C354.717 159.304 355.017 158.521 355.057 157.703C355.06 157.664 355.041 157.632 355.014 157.63C354.988 157.63 354.964 157.66 354.962 157.7C354.883 159.031 354.037 160.182 352.853 160.774C352.021 161.194 350.995 161.241 350.123 160.872C349.247 160.513 348.539 159.743 348.274 158.824C347.989 157.851 348.159 156.819 348.672 156.048C349.183 155.273 350.019 154.756 350.902 154.653C351.521 154.587 352.119 154.656 352.669 154.864C353.219 155.074 353.721 155.429 354.106 155.92C354.291 156.165 354.438 156.433 354.557 156.717C354.669 157.004 354.741 157.306 354.789 157.621C354.792 157.63 354.799 157.635 354.806 157.63C354.812 157.627 354.815 157.617 354.811 157.606Z",
  fill: "#ECECEC"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M354.17 157.611C354.073 156.834 353.665 156.169 353.091 155.726C352.512 155.291 351.785 155.076 351.017 155.151C350.286 155.226 349.582 155.636 349.128 156.273C348.67 156.902 348.483 157.778 348.689 158.639C348.851 159.347 349.344 159.977 349.981 160.326C350.613 160.68 351.371 160.778 352.048 160.607C352.725 160.446 353.323 160.052 353.728 159.522C354.135 158.994 354.378 158.36 354.416 157.69C354.418 157.658 354.4 157.632 354.372 157.63C354.346 157.63 354.323 157.654 354.32 157.687C354.245 158.769 353.556 159.684 352.606 160.181C351.939 160.534 351.094 160.584 350.38 160.285C349.663 159.994 349.081 159.356 348.877 158.604C348.656 157.808 348.809 156.968 349.234 156.358C349.657 155.742 350.338 155.343 351.037 155.28C351.527 155.242 351.996 155.299 352.428 155.458C352.859 155.619 353.26 155.892 353.573 156.276C353.722 156.468 353.842 156.679 353.942 156.903C354.036 157.13 354.099 157.369 354.147 157.623C354.151 157.63 354.158 157.635 354.164 157.63C354.171 157.627 354.172 157.62 354.17 157.611Z",
  fill: "#ECECEC"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M411.823 170.277H404.088L405.049 163.067H410.862L411.823 170.277Z",
  fill: "#C8C8C8"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M415.164 157.913C415.164 161.895 411.936 165.122 407.955 165.122C403.974 165.122 400.746 161.895 400.746 157.913C400.746 153.932 403.974 150.704 407.955 150.704C411.936 150.704 415.164 153.932 415.164 157.913Z",
  fill: "#DCDCDC"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M413.436 157.914C413.436 160.94 410.982 163.393 407.955 163.393C404.928 163.393 402.476 160.94 402.476 157.914C402.476 154.887 404.928 152.434 407.955 152.434C410.982 152.434 413.436 154.887 413.436 157.914Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M412.537 157.597C412.44 156.257 411.759 155.025 410.747 154.233C409.732 153.438 408.39 153.07 407.062 153.268C405.777 153.46 404.611 154.222 403.893 155.328C403.167 156.434 402.921 157.885 403.315 159.281C403.633 160.425 404.432 161.417 405.455 161.989C406.477 162.572 407.701 162.751 408.81 162.505C409.926 162.271 410.932 161.645 411.624 160.782C412.321 159.925 412.738 158.843 412.782 157.73C412.784 157.676 412.766 157.632 412.739 157.631C412.713 157.631 412.689 157.671 412.686 157.725C412.668 158.177 412.569 158.621 412.43 159.046C412.281 159.47 412.073 159.867 411.825 160.236C411.567 160.6 411.264 160.929 410.927 161.222C410.582 161.509 410.201 161.755 409.789 161.958C408.627 162.515 407.241 162.555 406.048 162.047C404.857 161.549 403.897 160.516 403.511 159.263C403.096 157.938 403.301 156.521 403.99 155.427C404.675 154.336 405.821 153.58 407.075 153.399C408.806 153.15 410.554 153.785 411.615 155.206C411.87 155.556 412.071 155.941 412.226 156.345C412.375 156.752 412.466 157.18 412.514 157.618C412.517 157.631 412.524 157.635 412.53 157.631C412.537 157.626 412.539 157.611 412.537 157.597Z",
  fill: "#ECECEC"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M411.894 157.601C411.798 156.45 411.208 155.406 410.341 154.731C409.473 154.055 408.335 153.739 407.194 153.895C406.094 154.048 405.082 154.693 404.452 155.643C403.815 156.59 403.589 157.849 403.92 159.067C404.186 160.065 404.883 160.937 405.778 161.435C406.67 161.941 407.738 162.094 408.703 161.872C409.673 161.662 410.543 161.114 411.139 160.362C411.739 159.615 412.098 158.682 412.14 157.716C412.143 157.67 412.124 157.632 412.097 157.631C412.071 157.631 412.047 157.666 412.045 157.713C411.963 159.292 410.959 160.678 409.542 161.366C408.544 161.855 407.339 161.898 406.306 161.459C405.273 161.031 404.439 160.13 404.113 159.044C403.763 157.895 403.951 156.67 404.552 155.738C405.15 154.804 406.14 154.168 407.209 154.026C408.688 153.834 410.161 154.357 411.082 155.562C411.302 155.861 411.475 156.187 411.613 156.531C411.742 156.878 411.824 157.242 411.872 157.62C411.875 157.631 411.882 157.635 411.889 157.631C411.895 157.626 411.898 157.614 411.894 157.601Z",
  fill: "#ECECEC"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M411.253 157.606C411.157 156.642 410.657 155.788 409.937 155.228C409.214 154.673 408.281 154.408 407.326 154.523C406.412 154.637 405.553 155.165 405.011 155.958C404.464 156.745 404.257 157.813 404.525 158.853C404.739 159.706 405.334 160.457 406.1 160.881C406.863 161.311 407.776 161.435 408.597 161.24C409.42 161.054 410.154 160.583 410.655 159.942C411.159 159.304 411.459 158.521 411.5 157.703C411.501 157.664 411.483 157.632 411.456 157.63C411.43 157.63 411.406 157.66 411.403 157.7C411.325 159.031 410.479 160.182 409.295 160.774C408.462 161.194 407.437 161.241 406.564 160.872C405.689 160.513 404.981 159.743 404.716 158.824C404.43 157.851 404.601 156.819 405.113 156.048C405.625 155.273 406.46 154.756 407.344 154.653C407.962 154.587 408.561 154.656 409.111 154.864C409.66 155.074 410.163 155.429 410.548 155.92C410.733 156.165 410.88 156.433 410.998 156.717C411.11 157.004 411.183 157.306 411.231 157.621C411.234 157.63 411.241 157.635 411.247 157.63C411.254 157.627 411.256 157.617 411.253 157.606Z",
  fill: "#ECECEC"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M410.611 157.611C410.515 156.834 410.107 156.169 409.532 155.726C408.955 155.291 408.227 155.076 407.458 155.151C406.729 155.226 406.023 155.636 405.57 156.273C405.112 156.902 404.925 157.778 405.13 158.639C405.294 159.347 405.786 159.977 406.423 160.326C407.055 160.68 407.813 160.778 408.49 160.607C409.167 160.446 409.764 160.052 410.17 159.522C410.577 158.994 410.82 158.36 410.858 157.69C410.86 157.658 410.841 157.632 410.814 157.63C410.788 157.63 410.765 157.654 410.762 157.687C410.686 158.769 409.998 159.684 409.048 160.181C408.38 160.534 407.535 160.584 406.822 160.285C406.105 159.994 405.523 159.356 405.319 158.604C405.098 157.808 405.252 156.968 405.675 156.358C406.099 155.742 406.78 155.343 407.478 155.28C407.969 155.242 408.437 155.299 408.869 155.458C409.3 155.619 409.702 155.892 410.015 156.276C410.165 156.468 410.284 156.679 410.385 156.903C410.477 157.13 410.541 157.369 410.589 157.623C410.592 157.63 410.599 157.635 410.606 157.63C410.612 157.627 410.615 157.62 410.611 157.611Z",
  fill: "#ECECEC"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M428.422 185.195H331.214V166.602H428.422V185.195Z",
  fill: "#DCDCDC"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M351.193 166.602L344.138 185.195H331.585L338.64 166.602H351.193Z",
  fill: "#ECECEC"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M376.927 166.602L369.872 185.195H357.314L364.37 166.602H376.927Z",
  fill: "#ECECEC"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M402.657 166.602L395.602 185.195H383.048L390.104 166.602H402.657Z",
  fill: "#ECECEC"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M428.39 166.602L421.335 185.195H408.777L415.833 166.602H428.39Z",
  fill: "#ECECEC"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M426.455 214.152H333.182V202.385H426.455V214.152Z",
  fill: "#DCDCDC"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M352.352 202.385L345.583 214.152H333.538L340.307 202.385H352.352Z",
  fill: "#ECECEC"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M377.044 202.385L370.275 214.152H358.226L364.995 202.385H377.044Z",
  fill: "#ECECEC"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M401.732 202.385L394.962 214.152H382.917L389.687 202.385H401.732Z",
  fill: "#ECECEC"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M426.424 202.385L419.655 214.152H407.605L414.374 202.385H426.424Z",
  fill: "#ECECEC"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M350.424 218.688C350.424 223.106 346.842 226.688 342.424 226.688H121.075C116.657 226.688 113.075 223.106 113.075 218.688V75.9195C113.075 71.5012 116.657 67.9195 121.075 67.9195H342.424C346.842 67.9195 350.424 71.5012 350.424 75.9195V218.688Z",
  fill: "#DCDCDC"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M348.699 216.751C348.699 221.169 345.117 224.751 340.699 224.751H122.801C118.383 224.751 114.801 221.169 114.801 216.751V77.8557C114.801 73.4374 118.383 69.8557 122.801 69.8557H340.699C345.117 69.8557 348.699 73.4374 348.699 77.8557V216.751Z",
  fill: "#B0B0B0"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M381.337 238.593C381.337 240.745 379.593 242.49 377.441 242.49H86.0589C83.9069 242.49 82.1624 240.745 82.1624 238.593H381.337Z",
  fill: "#C8C8C8"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M82.1626 238.593L112.382 226.955C112.84 226.778 113.328 226.687 113.819 226.687H349.68C350.172 226.687 350.659 226.778 351.118 226.955L381.338 238.593H82.1626Z",
  fill: "#DCDCDC"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M115.837 234.37L135.785 226.688H327.714L347.664 234.37H115.837Z",
  fill: "#B0B0B0"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M335.656 213.039H127.844V81.5686H335.656V213.039Z",
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M335.656 86.6276H127.844V81.5686H335.656V86.6276Z",
  fill: "#3E5C69"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M36.86 223.68L36.2692 227.881L35.6333 232.396L29.8284 273.565H20.3359L26.1408 232.396L26.7767 227.881L27.3675 223.68H36.86Z",
  fill: "#F5841F"
});

var _ref40 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M64.5845 220.214C64.0845 224.384 63.5469 228.547 63.003 232.71L61.3295 245.188L59.5756 257.653L58.6702 263.879L57.7278 270.1L58.4997 263.848L59.3086 257.603L60.9828 245.125L62.7373 232.661C63.3368 228.509 63.9418 224.357 64.5845 220.214Z",
  fill: "black"
})));

var _ref41 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M65.369 224.415L64.7331 228.929H55.2406L55.8765 224.415H65.369Z",
  fill: "black"
})));

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M83.7197 223.68L84.3105 227.881L84.9471 232.396L90.7513 273.565H100.244L94.4396 232.396L93.803 227.881L93.2122 223.68H83.7197Z",
  fill: "#F5841F"
});

var _ref43 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M114.225 220.214C114.725 224.384 115.263 228.547 115.806 232.71L117.48 245.188L119.234 257.653L120.139 263.879L121.082 270.1L120.31 263.848L119.501 257.603L117.827 245.125L116.072 232.661C115.473 228.509 114.868 224.357 114.225 220.214Z",
  fill: "black"
})));

var _ref44 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M113.41 224.415H122.903L123.539 228.929H114.047L113.41 224.415Z",
  fill: "black"
})));

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M65.6139 211.578H58.0873L59.0229 204.561H64.6782L65.6139 211.578Z",
  fill: "#F5841F"
});

var _ref46 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M36.514 215.044H28.9874L29.9231 208.027H35.5784L36.514 215.044Z",
  fill: "black"
})));

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M39.7648 203.014C39.7648 206.888 36.6241 210.029 32.7505 210.029C28.8769 210.029 25.7368 206.888 25.7368 203.014C25.7368 199.14 28.8769 196 32.7505 196C36.6241 196 39.7648 199.14 39.7648 203.014Z",
  fill: "#F5841F"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M38.0828 203.014C38.0828 205.959 35.6955 208.346 32.7507 208.346C29.8059 208.346 27.4186 205.959 27.4186 203.014C27.4186 200.069 29.8059 197.682 32.7507 197.682C35.6955 197.682 38.0828 200.069 38.0828 203.014Z",
  fill: "white"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2076 202.705C37.1137 201.403 36.4512 200.204 35.4667 199.433C34.4791 198.659 33.1733 198.301 31.8804 198.494C30.6315 198.68 29.4962 199.422 28.7985 200.498C28.0915 201.575 27.8523 202.986 28.2361 204.344C28.5445 205.458 29.3219 206.423 30.3181 206.98C31.3125 207.546 32.5028 207.72 33.5818 207.482C34.6682 207.253 35.6472 206.645 36.3202 205.806C36.9981 204.971 37.4035 203.918 37.4468 202.834C37.4499 202.784 37.4313 202.741 37.4047 202.739C37.3794 202.739 37.3565 202.778 37.3535 202.831C37.3355 203.271 37.2391 203.703 37.1044 204.116C36.9592 204.528 36.7571 204.915 36.5148 205.274C36.2645 205.628 35.9704 205.947 35.641 206.233C35.306 206.512 34.9352 206.751 34.5341 206.948C33.4032 207.491 32.0553 207.53 30.8947 207.036C29.736 206.551 28.8016 205.546 28.4264 204.328C28.0229 203.038 28.2219 201.659 28.893 200.595C29.5592 199.533 30.6735 198.798 31.8934 198.621C33.5781 198.379 35.2788 198.997 36.3103 200.379C36.5593 200.72 36.7546 201.095 36.906 201.488C37.0506 201.885 37.1384 202.3 37.186 202.726C37.1884 202.739 37.1959 202.743 37.202 202.739C37.2076 202.734 37.2101 202.719 37.2076 202.705Z",
  fill: "#F5841F"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M36.5835 202.71C36.4895 201.59 35.9154 200.575 35.0731 199.917C34.227 199.26 33.1202 198.952 32.0096 199.105C30.9399 199.253 29.9542 199.88 29.3423 200.805C28.7225 201.726 28.5025 202.952 28.8251 204.136C29.0828 205.109 29.7614 205.956 30.6321 206.44C31.4998 206.933 32.5393 207.081 33.4786 206.866C34.4223 206.662 35.2683 206.128 35.8487 205.396C36.4327 204.669 36.7812 203.761 36.8232 202.822C36.8251 202.777 36.8072 202.74 36.7806 202.738C36.7553 202.738 36.7324 202.773 36.7293 202.818C36.6502 204.355 35.6731 205.704 34.2944 206.373C33.3241 206.848 32.1512 206.891 31.1463 206.464C30.1408 206.047 29.3294 205.17 29.013 204.114C28.6718 202.996 28.8547 201.803 29.4394 200.897C30.0209 199.989 30.985 199.37 32.0251 199.231C33.4632 199.044 34.8969 199.553 35.7924 200.726C36.0062 201.016 36.175 201.334 36.3091 201.669C36.4351 202.007 36.5149 202.361 36.5618 202.728C36.5649 202.738 36.5717 202.743 36.5779 202.738C36.5841 202.734 36.5859 202.722 36.5835 202.71Z",
  fill: "#F5841F"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M35.9593 202.715C35.8647 201.777 35.3796 200.946 34.6788 200.402C33.9749 199.861 33.0677 199.603 32.1382 199.715C31.2483 199.826 30.4127 200.339 29.8862 201.111C29.3529 201.878 29.152 202.916 29.4134 203.928C29.6217 204.759 30.2008 205.489 30.9455 205.901C31.6871 206.319 32.5751 206.441 33.3748 206.251C34.1757 206.07 34.8895 205.611 35.3765 204.988C35.8672 204.367 36.1595 203.605 36.1991 202.809C36.2009 202.772 36.1824 202.74 36.1558 202.738C36.1311 202.738 36.1076 202.767 36.1051 202.806C36.0291 204.1 35.2053 205.221 34.054 205.796C33.2438 206.206 32.2463 206.251 31.3972 205.893C30.5456 205.543 29.8565 204.794 29.5988 203.9C29.3207 202.953 29.487 201.949 29.9857 201.199C30.4832 200.445 31.2959 199.942 32.1555 199.842C32.7574 199.778 33.339 199.844 33.8748 200.047C34.4093 200.251 34.8988 200.596 35.2733 201.074C35.4531 201.312 35.5953 201.573 35.7115 201.85C35.8196 202.129 35.8901 202.423 35.937 202.73C35.9408 202.738 35.9475 202.743 35.9537 202.738C35.9593 202.735 35.9618 202.725 35.9593 202.715Z",
  fill: "#F5841F"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M35.3352 202.719C35.2407 201.964 34.8433 201.316 34.2846 200.886C33.7229 200.463 33.0146 200.253 32.2675 200.326C31.5568 200.399 30.8708 200.798 30.4302 201.418C29.984 202.029 29.8017 202.882 30.0019 203.72C30.1601 204.409 30.6397 205.022 31.2589 205.36C31.8744 205.705 32.6117 205.801 33.2711 205.635C33.9293 205.478 34.5108 205.095 34.9051 204.579C35.3019 204.065 35.5373 203.449 35.575 202.796C35.5769 202.765 35.5583 202.74 35.5318 202.738C35.5064 202.738 35.4836 202.762 35.4811 202.793C35.4082 203.846 34.7382 204.737 33.8137 205.221C33.1642 205.564 32.3416 205.612 31.6476 205.321C30.9499 205.039 30.3832 204.417 30.1854 203.686C29.9704 202.912 30.1199 202.094 30.5321 201.5C30.945 200.901 31.6068 200.513 32.286 200.452C32.7637 200.415 33.2198 200.469 33.6394 200.625C34.0591 200.782 34.4496 201.047 34.7549 201.421C34.9002 201.608 35.0157 201.813 35.114 202.031C35.2048 202.251 35.266 202.484 35.313 202.732C35.3161 202.738 35.3229 202.743 35.3297 202.738C35.3352 202.736 35.3377 202.728 35.3352 202.719Z",
  fill: "#F5841F"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M91.4296 215.044H83.903L84.8386 208.027H90.4939L91.4296 215.044Z",
  fill: "#F5841F"
});

var _ref54 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.100006
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.100006,
  d: "M91.4296 215.044H83.903L84.8386 208.027H90.4939L91.4296 215.044Z",
  fill: "black"
})));

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M94.6804 203.014C94.6804 206.888 91.5398 210.029 87.6661 210.029C83.7925 210.029 80.6525 206.888 80.6525 203.014C80.6525 199.14 83.7925 196 87.6661 196C91.5398 196 94.6804 199.14 94.6804 203.014Z",
  fill: "#F5841F"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M92.9984 203.014C92.9984 205.959 90.6111 208.346 87.6663 208.346C84.7216 208.346 82.3342 205.959 82.3342 203.014C82.3342 200.069 84.7216 197.682 87.6663 197.682C90.6111 197.682 92.9984 200.069 92.9984 203.014Z",
  fill: "white"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M92.1234 202.705C92.0294 201.403 91.3669 200.204 90.3825 199.433C89.3949 198.659 88.0891 198.301 86.7962 198.494C85.5472 198.68 84.4114 199.422 83.7142 200.498C83.0073 201.575 82.7681 202.986 83.1519 204.344C83.4603 205.458 84.2371 206.423 85.2339 206.98C86.2283 207.546 87.4185 207.72 88.4976 207.482C89.584 207.253 90.5629 206.645 91.2359 205.806C91.9139 204.971 92.3187 203.918 92.3625 202.834C92.365 202.784 92.3471 202.741 92.3199 202.739C92.2952 202.739 92.2717 202.778 92.2692 202.831C92.2513 203.271 92.1549 203.703 92.0202 204.116C91.8743 204.528 91.6729 204.915 91.4306 205.274C91.1803 205.628 90.8861 205.947 90.5567 206.233C90.2218 206.512 89.8504 206.751 89.4499 206.948C88.319 207.491 86.9711 207.53 85.8105 207.036C84.6518 206.551 83.7173 205.546 83.3422 204.328C82.938 203.038 83.1377 201.659 83.8082 200.595C84.475 199.533 85.5893 198.798 86.8092 198.621C88.4939 198.379 90.1946 198.997 91.226 200.379C91.4751 200.72 91.6704 201.095 91.8218 201.488C91.9664 201.885 92.0542 202.3 92.1011 202.726C92.1042 202.739 92.1116 202.743 92.1178 202.739C92.1234 202.734 92.1258 202.719 92.1234 202.705Z",
  fill: "#F5841F"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M91.4989 202.71C91.405 201.59 90.8309 200.575 89.9879 199.917C89.1425 199.26 88.0357 198.952 86.9251 199.105C85.8554 199.253 84.8697 199.88 84.2578 200.805C83.638 201.726 83.418 202.952 83.7399 204.136C83.9989 205.109 84.6762 205.956 85.5476 206.44C86.4153 206.933 87.4547 207.081 88.3941 206.866C89.3378 206.662 90.1838 206.128 90.7641 205.396C91.3481 204.669 91.6967 203.761 91.7387 202.822C91.7406 202.777 91.7227 202.74 91.6961 202.738C91.6707 202.738 91.6473 202.773 91.6448 202.818C91.5657 204.355 90.5886 205.704 89.2092 206.373C88.239 206.848 87.0666 206.891 86.0618 206.464C85.0563 206.047 84.2449 205.17 83.9284 204.114C83.5873 202.996 83.7702 201.803 84.3549 200.897C84.9364 199.989 85.9005 199.37 86.94 199.231C88.3787 199.044 89.8124 199.553 90.7073 200.726C90.9217 201.016 91.0904 201.334 91.2245 201.669C91.3506 202.007 91.4297 202.361 91.4767 202.728C91.4804 202.738 91.4872 202.743 91.4934 202.738C91.4989 202.734 91.5014 202.722 91.4989 202.71Z",
  fill: "#F5841F"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M90.8751 202.715C90.7805 201.777 90.2954 200.946 89.5946 200.402C88.8907 199.861 87.9828 199.603 87.054 199.715C86.1641 199.826 85.3285 200.339 84.8014 201.111C84.2687 201.878 84.0678 202.916 84.3292 203.928C84.5375 204.759 85.1166 205.489 85.8612 205.901C86.6028 206.319 87.4909 206.441 88.29 206.251C89.0915 206.07 89.8053 205.611 90.2923 204.988C90.783 204.367 91.0753 203.605 91.1149 202.809C91.1167 202.772 91.0982 202.74 91.0716 202.738C91.0463 202.738 91.0234 202.767 91.0209 202.806C90.9449 204.1 90.1211 205.221 88.9698 205.796C88.1596 206.206 87.1621 206.251 86.3124 205.893C85.4614 205.543 84.7717 204.794 84.5146 203.9C84.2365 202.953 84.4028 201.949 84.9015 201.199C85.3984 200.445 86.2117 199.942 87.0713 199.842C87.6732 199.778 88.2548 199.844 88.7906 200.047C89.3251 200.251 89.8146 200.596 90.1891 201.074C90.3689 201.312 90.5111 201.573 90.6273 201.85C90.7354 202.129 90.8059 202.423 90.8528 202.73C90.8559 202.738 90.8633 202.743 90.8695 202.738C90.8751 202.735 90.8776 202.725 90.8751 202.715Z",
  fill: "#F5841F"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M90.2506 202.719C90.1561 201.964 89.7587 201.316 89.2006 200.886C88.6383 200.463 87.93 200.253 87.1829 200.326C86.4722 200.399 85.7868 200.798 85.3456 201.418C84.8994 202.029 84.7177 202.882 84.9179 203.72C85.0755 204.409 85.5557 205.022 86.1749 205.36C86.7898 205.705 87.5271 205.801 88.1865 205.635C88.8447 205.478 89.4262 205.095 89.8205 204.579C90.2173 204.065 90.4527 203.449 90.4904 202.796C90.4923 202.765 90.4743 202.74 90.4478 202.738C90.4224 202.738 90.3996 202.762 90.3965 202.793C90.3235 203.846 89.6536 204.737 88.7291 205.221C88.0796 205.564 87.2576 205.612 86.5636 205.321C85.8659 205.039 85.2992 204.417 85.1008 203.686C84.8858 202.912 85.0353 202.094 85.4481 201.5C85.8604 200.901 86.5228 200.513 87.202 200.452C87.6791 200.415 88.1358 200.469 88.5548 200.625C88.9751 200.782 89.365 201.047 89.6703 201.421C89.8156 201.608 89.9311 201.813 90.0294 202.031C90.1202 202.251 90.182 202.484 90.2284 202.732C90.2315 202.738 90.2389 202.743 90.2451 202.738C90.2506 202.736 90.2531 202.728 90.2506 202.719Z",
  fill: "#F5841F"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M107.58 229.558H13V211.468H107.58V229.558Z",
  fill: "white",
  stroke: "#B0B0B0",
  strokeWidth: 0.309,
  strokeMiterlimit: 10
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M32.4388 211.468L25.5746 229.558H13.3605L20.2246 211.468H32.4388Z",
  fill: "#F5841F"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M57.4771 211.468L50.613 229.558H38.3945L45.2587 211.468H57.4771Z",
  fill: "#F5841F"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M82.5107 211.468L75.6465 229.558H63.4324L70.2965 211.468H82.5107Z",
  fill: "#F5841F"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M107.549 211.468L100.685 229.558H88.4663L95.3304 211.468H107.549Z",
  fill: "#F5841F"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M105.665 263.118H14.9146V251.669H105.665V263.118Z",
  fill: "white",
  stroke: "#B0B0B0",
  strokeWidth: 0.309,
  strokeMiterlimit: 10
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5664 251.669L26.9798 263.118H15.2606L21.8473 251.669H33.5664Z",
  fill: "#F5841F"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M57.5909 251.669L51.0042 263.118H39.2808L45.8668 251.669H57.5909Z",
  fill: "#F5841F"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M81.6111 251.669L75.0244 263.118H63.3053L69.8919 251.669H81.6111Z",
  fill: "#F5841F"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M105.636 251.669L99.0489 263.118H87.3254L93.9115 251.669H105.636Z",
  fill: "#F5841F"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M75.0077 220.513C75.0077 228.641 68.418 235.23 60.2901 235.23C52.1615 235.23 45.5724 228.641 45.5724 220.513C45.5724 212.385 52.1615 205.796 60.2901 205.796C68.418 205.796 75.0077 212.385 75.0077 220.513Z",
  fill: "white"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M75.0077 220.513C75.0077 228.641 68.418 235.23 60.2901 235.23C52.1615 235.23 45.5724 228.641 45.5724 220.513C45.5724 212.385 52.1615 205.796 60.2901 205.796C68.418 205.796 75.0077 212.385 75.0077 220.513Z",
  stroke: "#B0B0B0",
  strokeWidth: 0.309,
  strokeMiterlimit: 10
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M72.7695 220.513C72.7695 227.405 67.1821 232.992 60.2902 232.992C53.3976 232.992 47.8103 227.405 47.8103 220.513C47.8103 213.621 53.3976 208.033 60.2902 208.033C67.1821 208.033 72.7695 213.621 72.7695 220.513Z",
  fill: "#F5841F"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M68.1145 221.962H52.4648V219.063H68.1145V221.962Z",
  fill: "white"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M215.906 122.688C215.906 114.714 222.37 108.25 230.344 108.25C238.317 108.25 244.781 114.714 244.781 122.688V126.812H248.906C254.032 126.812 258.188 130.968 258.188 136.094V167.031C258.188 172.157 254.032 176.312 248.906 176.312H211.781C206.655 176.312 202.5 172.157 202.5 167.031V136.094C202.5 130.968 206.655 126.812 211.781 126.812H215.906V122.688ZM238.594 122.688C238.594 118.131 234.9 114.438 230.344 114.438C225.787 114.438 222.094 118.131 222.094 122.688V126.812H238.594V122.688ZM230.344 156.719C233.191 156.719 235.5 154.41 235.5 151.562C235.5 148.715 233.191 146.406 230.344 146.406C227.496 146.406 225.188 148.715 225.188 151.562C225.188 154.41 227.496 156.719 230.344 156.719ZM217.465 180.438C218.739 184.042 222.177 186.625 226.218 186.625H250.968C260.651 186.625 268.5 178.776 268.5 169.094V150.531C268.5 146.49 265.917 143.052 262.312 141.778V169.094C262.312 175.359 257.233 180.438 250.968 180.438H217.465Z",
  fill: "#3E5C69"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M217.465 180.438C218.739 184.042 222.177 186.625 226.218 186.625H250.968C260.651 186.625 268.5 178.776 268.5 169.094V150.531C268.5 146.49 265.917 143.052 262.312 141.778V169.094C262.312 175.359 257.233 180.438 250.968 180.438H217.465Z",
  fill: "#B0B0B0"
});

function SvgNoPermission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 309,
    viewBox: "0 0 464 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPermission);
export default __webpack_public_path__ + "static/media/no-permission.702e492f.svg";
export { ForwardRef as ReactComponent };